export interface GrowlersCartRules {
  /** A partir desta quantidade de itens, aplica discountPercent. 0 = desativado. */
  discountMinItems: number;
  /** Percentual de desconto no subtotal (0 a 100). 0 = desativado. */
  discountPercent: number;
  /** Taxa fixa de entrega em reais. */
  shippingFee: number;
  /** Subtotal a partir do qual o frete é grátis. 0 = desativado. */
  freeShippingMinValue: number;
}

export const DEFAULT_GROWLERS_CART_RULES: GrowlersCartRules = {
  discountMinItems: 0,
  discountPercent: 0,
  shippingFee: 0,
  freeShippingMinValue: 0,
};

export const GROWLERS_CART_RULES_DOC_ID = 'growlers_cart_rules';
